<template>
    <div class="air-container " :class="order_show ? 'air-container_active' : ''" v-if="order">
        <div class="popup-air " :class="order_show ? 'popup-air_active' : ''">
            <div class="air-close" @click.prevent="order_show = false"></div>
            <div class="order-info-modal">
                <p class="form-popup__title">{{ trans("Order number") }}
                    : {{ order.id }}</p>
                <div>
                    <div class="cart-sec__element cart-element" v-for="card in order.cards">
                        <a :href="card.img_first.webp" target="_blank" class="cart-element__img">
                            <picture>
                                <source :srcset="card.img_first.webp"
                                        type="image/webp">
                                <img class="img-element" :src="card.img_first.jpeg"
                                     alt="">
                            </picture>
                        </a>
                        <div class="cart-element__info">
                            <h3 class="cart-element__title">
                                <a class="cart-element__link" :href="card.slug" >
                                    {{card.name}}
                                </a>
                            </h3>
                            <div class="cart-element__size">{{ trans("size") }}:
                                <b>{{ card.offer.size.code }}</b>
                            </div>
                            <template v-if="card.price_old">
                                <p class="product__sale-price product__text-def"> {{ card.price }} {{ card.signs }}</p>
                                <p class="product__old-price"> {{ card.price_old }} {{ card.signs }}</p>
                            </template>

                            <p class="product__main-price product__text-def" v-if="!card.price_old">{{ card.price }}
                                {{ card.signs }}</p>

                        </div>
                    </div>
                </div>

                <table class="order-page__price-table table">
                    <tbody>
                        <tr v-for="(item, index) in order.info.body" :key="index">
                            <td class="order-view-page__table-header">{{ item.name }}</td>
                            <td class="order-page__price-table-value-cell">{{ item.value }}</td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="showPayLink" class="order-pay-action">
                    <a :href="payThanksUrl" class="btn btnV2">{{ trans('To pay') }}</a>
                </div>

                <table class="order-page__price-table table">
                    <tbody>
                        <tr v-for="item in order.info.head">
                            <td class="order-view-page__table-header">{{ item.name }}</td>
                            <td class="order-page__price-table-value-cell">{{item.value}}</td>
                        </tr>
                    </tbody>
                </table>

                <table class="order-page__price-table table pb-4">
                    <tbody>
                        <tr v-for="item in order.info.total">
                            <td class="order-view-page__table-header">{{ item.name }}</td>
                            <td class="order-page__price-table-value-cell">{{item.value}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    data(){
        return{
            order_show:false,
            order:null,
        }
    },
    computed: {
        showPayLink() {
            if (!this.order) {
                return false
            }
            const statusId = Number(this.order.status_id)
            const isPaid = Number(this.order.document_id) === 1 || Boolean(this.order.payment_date)
            return this.order.payment_method !== 'cash'
                && !isPaid
                && (statusId === 2 || statusId === 6)
        },
        payThanksUrl() {
            const id = this.order.thanks_id
                ?? `${this.order.guest_id}-${this.order.id}`
            return `/personal/order/thanks/${id}`
        },
    },
    mounted() {

    },
    name: "order"
}
</script>

<style scoped>
.table table, .table th, .table td {
    padding: 10px;
    border: 1px solid black;
    border-collapse: collapse;
}
.pb-4{
    padding-bottom: 30px;
}
.order-pay-action {
    margin: 12px 0 16px;
    text-align: center;
}
</style>
